import notifications from './index';

const STORAGE_KEY = 'flash_notification';
const DEFAULT_TYPE = 'success';

/**
 * A notification for after the next document load, for the flows that still have to reload:
 * joining a group or a circle, logging in. Those change who you are, and `$user` is rendered
 * into the document, so they set `document.location.href` - a toast shown before that goes
 * away with the document. This is what django's flash messages used to cover.
 *
 * @param {string} message
 * @param {string} [type] a notifications method name: success, error, warning, message
 */
export function flashAfterReload (message, type = DEFAULT_TYPE) {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({message, type}));
    } catch (e) {
        // no storage (private mode, blocked site data) - not worth failing the flow over
    }
}

/**
 * Shows the flash the previous document left, if any. Runs on every page - see src/index.js.
 */
export function replayFlash () {
    let stored;
    try {
        stored = sessionStorage.getItem(STORAGE_KEY);
        if (stored) {
            sessionStorage.removeItem(STORAGE_KEY);
        }
    } catch (e) {
        return;
    }
    if (!stored) {
        return;
    }
    let flash;
    try {
        flash = JSON.parse(stored);
    } catch (e) {
        return;
    }
    if (!flash || !flash.message) {
        return;
    }
    const show = notifications[flash.type] || notifications[DEFAULT_TYPE];
    show(flash.message);
}

export default flashAfterReload;
